import {parseReference} from '@apps-common/geocorn-sdk/api/util';
import {type FeatureRef} from '@src/types/featureCollections.ts';
import {createHash} from 'crypto';

// In these utilities, we often just look at the last 7 chars to extract the last hashid
const HASHID_LENGTH = 7;

export const getHashFromId = (id?: string) => {
  if (!id) {
    return '';
  }

  return id.slice(-HASHID_LENGTH);
};

export const hashStringSHA256 = (message?: string) => {
  if (!message) {
    return;
  }

  return createHash('sha256').update(message).digest('hex');
};

export const refEquals = (ref1: FeatureRef, ref2: FeatureRef) => {
  if (!ref1 || !ref2) {
    return false;
  }

  const parsedRef1 = parseReference(ref1);
  const parsedRef2 = parseReference(ref2);

  if (
    (parsedRef1.featureId && !parsedRef2.featureId) ||
    (!parsedRef1.featureId && parsedRef2.featureId)
  ) {
    return false;
  }

  return (
    getHashFromId(parsedRef1.featureId) === getHashFromId(parsedRef2.featureId)
  );
};
